import React from "react";
import ReactGA from "react-ga4";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
// --- Import components
import UserData from "./components/UserData/UserData";
import LoginRoute from "./components/LoginRoute/LoginRoute";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import Subscriptions from "./pages/Subscriptions/Subscriptions";
import Refund from "./pages/Refund/Refund";
import MyApps from "./pages/MyApps/MyApps";
import Profile from "./pages/Profile/Profile";
import Page404 from "./pages/Page404/Page404";
import RestorePassword from "./pages/Auth/Login/RestorePassword/RestorePassword";

import Transaction from "./pages/Transaction/Transaction";
// --- Import styles
import "./App.sass";

const GA4_TRACKING_ID = "G-VFQWFX3X1C";

if (process.env.NODE_ENV !== "development") {
  ReactGA.initialize(GA4_TRACKING_ID);
}
function App() {
  const currentLoc =
    useHistory().location.pathname === "/login"
      ? "/myApps"
      : useHistory().location.pathname;
  return (
    <div className="mainWrapper">
      <Header />
      <UserData>
        <div className="container content">
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/myApps" />} />
            <LoginRoute path="/login" homeRoute={currentLoc} />
            <PrivateRoute path="/myApps">
              <MyApps />
            </PrivateRoute>
            <PrivateRoute path="/profile">
              <Profile />
            </PrivateRoute>
            <PrivateRoute path="/transaction">
              <Transaction />
            </PrivateRoute>
            <PrivateRoute path="/changePassword">
              <ChangePassword />
            </PrivateRoute>
            <PrivateRoute path="/subscriptions">
              <Subscriptions />
            </PrivateRoute>
            <PrivateRoute path="/refund">
              <Refund />
            </PrivateRoute>
            <Route path="/restorePassword" render={() => <RestorePassword />} />
            <Route component={Page404} />
          </Switch>
        </div>
        <Footer />
      </UserData>
    </div>
  );
}

export default App;
